import React from 'react';
import { FadeIn } from './FadeIn';
import { DownloadIcon, PenLineIcon, ZapIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    num: '1',
    icon: <DownloadIcon className="w-6 h-6 text-gold-dark" data-id="element-150" />,
    title: 'Descarga el Código',
    desc: 'Obtén acceso inmediato al sistema completo en PDF.'
  }, {
    num: '2',
    icon: <PenLineIcon className="w-6 h-6 text-gold-dark" data-id="element-151" />,
    title: 'Escribe tu Visión',
    desc: 'Sigue la plantilla para formalizar tu petición legal ante el Reino.'
  }, {
    num: '3',
    icon: <ZapIcon className="w-6 h-6 text-gold-dark" data-id="element-152" />,
    title: 'Ejecuta el Decreto',
    desc: 'Activa tu provisión diariamente con los scripts de poder incluidos.'
  }];
  return <section className="py-24 bg-white relative overflow-hidden border-y border-parchment-dark" data-id="element-153">
      <div className="container mx-auto px-4 relative z-10" data-id="element-154">
        <FadeIn data-id="element-155">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 text-ink" data-id="element-156">
            Cómo funciona
          </h2>
        </FadeIn>

        <div className="max-w-5xl mx-auto grid md:grid-cols-3 gap-8 relative" data-id="element-157">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[2px] bg-gold/20 z-0" data-id="element-158"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-159">
              <div className="flex flex-col items-center text-center" data-id="element-160">
                <div className="w-24 h-24 rounded-full bg-parchment border-4 border-gold/60 flex items-center justify-center mb-6 shadow-md relative" data-id="element-161">
                  <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-gold text-white font-bold flex items-center justify-center text-sm shadow-sm" data-id="element-162">
                    {step.num}
                  </div>
                  {step.icon}
                </div>
                <h3 className="text-xl font-bold font-serif text-navy mb-3" data-id="element-163">
                  {step.title}
                </h3>
                <p className="text-charcoal leading-relaxed" data-id="element-164">{step.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}